import React, { useEffect, useState } from 'react';
import { Button, Table } from 'antd';
import styles from './ReportTable.module.scss';
import useTableChange from '../../../HousingStock/hooks/useTableChange';
import useTablePagination from '../../../HousingStock/hooks/useTablePagination';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getTableItems } from './helpers/getTableItems';
import { reportTableComponents } from './components/reportTableComponents';
import cn from 'classnames';

export const ReportTable = () => {
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);

  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  const location = useLocation();

  const removeRowFromSelection = (rowId) => {
    const updateRowKeys = expandedRowKeys.filter((key) => key !== rowId);
    setExpandedRowKeys(updateRowKeys);
  };

  const addRowToSelection = (rowId) => {
    const updateRowKeys = [...expandedRowKeys, rowId];
    setExpandedRowKeys(updateRowKeys);
  };

  const handleRowClick = (rowId) => {
    if (expandedRowKeys.includes(rowId)) {
      removeRowFromSelection(rowId);
    } else {
      addRowToSelection(rowId);
    }
  };

  useEffect(() => {
    if (filteredRequests) {
      setTableData(filteredRequests);
    }
  }, [filteredRequests, location.pathname]);

  useEffect(() => {
    if (tableData.length) {
      const regionSet = new Set(
        tableData.map((item) => item.regionName ?? 'Без района')
      );
      const regionList = [...regionSet];

      const dynamicColumns = regionList.map((region) => ({
        title: region,
        dataIndex: region,
        key: region,
        render: (text) => (
          <span
            className={{
              [styles.highlighted]: !!text,
            }}
          >
            {text}
          </span>
        ),
      }));

      setTableColumns([
        {
          title: 'Сервис',
          dataIndex: 'service',
          key: 'service',
          render: (text) => {
            return (
              <span
                className={cn(styles.service, {
                  [styles.highlighted]: !!text,
                })}
              >
                {text}
              </span>

            );
          },
        },
        ...dynamicColumns,
        {
          title: '',
          key: 'actions',
          width: 40,
          render: (_text, record) => {
            return record.children ? (
              <Button
                className={styles.showMoreBtn}
                icon={
                  expandedRowKeys.includes(record.key)
                    ? 'caret-up'
                    : 'caret-down'
                }
              />
            ) : null;
          },
        },
      ]);
    }
  }, [expandedRowKeys, tableData]);

  useEffect(() => {
    if (tableColumns.length && tableData.length) {
      const tableItems = getTableItems(tableData);
      if (tableItems.length) {
        setDataSource(tableItems);
      }
    }
  }, [tableColumns.length, tableData]);

  const { data: sortedData, handleTableChange } = useTableChange({
    initialData: dataSource,
    sortableColumnKeys: [],
    filterableColumnKeys: [],
    depsToReset: [],
  });

  const { shownItems, pagination: paginationBlock } =
    useTablePagination(sortedData);

  return (
    <>
      <Table
        rowKey={(record) => record.key}
        columns={tableColumns}
        dataSource={shownItems}
        expandedRowKeys={expandedRowKeys}
        className={styles.root}
        pagination={false}
        onChange={handleTableChange}
        onRow={(record) => {
          return {
            onClick: () => handleRowClick(record.key),
            expanded: expandedRowKeys.includes(record.key),
          };
        }}
        components={reportTableComponents}
      />
      {paginationBlock}
    </>
  );
};
